import React from 'react';

/** Pass-through wrapper (no global redirect on backend errors). */
const BackendHealthCheck = ({ children }) => <>{children}</>;

export default BackendHealthCheck;
